var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<ul class=\"gallery gallery1\">\n<li ng-repeat=\"image in $wbImageGalleryCtrl.galleryImages\">\n<a ng-click=\"$wbImageGalleryCtrl.openLightboxModal($index)\">\n<div class=\"img-div\" ng-style=\"{'background-image':'url('+image.thumbUrl+')'}\"></div>\n</a>\n</li>\n</ul>";
var id1="javascripts/image-gallery/image_gallery.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/image-gallery/image_gallery.template.html
// module id = 1314
// module chunks = 0